import React from "react";
import { Table } from "antd";
import { BacktestSel, BacktestType } from "@/features/backtest";
import { useRootSelector } from "@/infrastructure/hooks";

export default () => {
  const strategyTradeLog = useRootSelector(BacktestSel.strategyTradeLog);

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      ...getFilters("date")
    },
    {
      title: "Ticker",
      dataIndex: "symbol",
      key: "symbol",
      ...getFilters("symbol")
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message"
    }
  ];

  return <Table columns={columns} dataSource={strategyTradeLog} />;

  function getFilters(filter: keyof BacktestType.TradeLog) {
    return {
      filters: [...new Set(strategyTradeLog.map(e => e[filter]))].map(e => ({
        text: e as string,
        value: e as string
      })),
      filterMultiple: true,
      onFilter: (value: any, record: any) => record[filter].indexOf(value) === 0
    };
  }
};
